import { createFileRoute } from '@tanstack/react-router';

import {
  BloodReportError,
  BloodReportPending,
  BloodReportShell,
  loadBloodReportCoreData,
} from '@/pages/blood-report';

export const Route = createFileRoute('/blood-report/_role-guard/$id')({
  component: BloodReportShell,
  errorComponent: BloodReportError,
  loader: async ({ context: { queryClient, user }, params: { id: carePlanId } }) => {
    const { bloodReport, patient } = await loadBloodReportCoreData(queryClient, carePlanId);

    return { bloodReport, carePlanId, patient, user };
  },
  pendingComponent: BloodReportPending,
});
